import Preferences from "@/views/Admin/Preferences.vue";
import Site from "@/views/Admin/Site.vue";
import Sites from "@/views/Admin/Sites.vue";
import User from "@/views/Admin/User.vue";
import Users from "@/views/Admin/Users.vue";
import ActivateAccount from "@/views/Auth/ActivateAccount.vue";
import Forgot from "@/views/Auth/ForgotPassword.vue";
import Login from "@/views/Auth/Login.vue";
import RequestAccess from "@/views/Auth/RequestAccess.vue";
import ResetPassword from "@/views/Auth/ResetPassword.vue";
import SSA from "@/views/SSA.vue";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
const routes: Array<RouteRecordRaw> = [
	{
		path: "/ssa",
		name: "SSA",
		component: SSA,
		meta: { layout: "SSALayout" }
	},
	{
		path: "/",
		name: "Login",
		component: Login
	},
	{
		path: "/help",
		name: "Help",
		component: Users
	},
	{
		path: "/forgot",
		name: "Forgot Password",
		component: Forgot
	},
	{
		path: "/activate-account",
		name: "Activate Account",
		component: ActivateAccount
	},
	{
		path: "/request-access",
		name: "Request Access",
		component: RequestAccess
	},
	{
		path: "/reset-password",
		name: "Reset Password",
		component: ResetPassword
	},
	{
		path: "/users",
		name: "Manage Users",
		component: Users,
		meta: { layout: "AdminLayout" }
	},
	{
		path: "/users/create",
		name: "Create User",
		component: User,
		meta: { layout: "AdminLayout" }
	},
	{
		path: "/preferences",
		name: "Preferences",
		component: Preferences,
		meta: { layout: "AdminLayout" }
	},
	{
		path: "/users/:id",
		name: "Edit User",
		component: User,
		meta: { layout: "AdminLayout" }
	},
	{
		path: "/sites",
		name: "Manage Sites",
		component: Sites,
		meta: { layout: "AdminLayout" }
	},
	{
		path: "/site/create",
		name: "Create Site",
		component: Site,
		meta: { layout: "AdminLayout" }
	},
	{
		path: "/site/:id",
		name: "Edit Site",
		component: Site,
		meta: { layout: "AdminLayout" }
	}
];

const router = createRouter({
	history: createWebHistory(),
	routes
});

export default router;
